import { render, staticRenderFns } from "./LoremIpsum.vue?vue&type=template&id=b81f3156&"
import script from "./LoremIpsum.vue?vue&type=script&lang=js&"
export * from "./LoremIpsum.vue?vue&type=script&lang=js&"
import style0 from "./LoremIpsum.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports